export default "__VITE_ASSET__K5NVJ8oM__"